import { deploymentsApi } from '../api/deploymentsApi';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

export const useDeleteDeployment = (
  options: DeploymentMutationOptions<{ deleted: boolean }> = {}
) =>
  useDeploymentMutation<string, { deleted: boolean }>({
    mutationFn: (id) => deploymentsApi.delete(id),
    invalidate: (qc) => qc.invalidateQueries({ queryKey: ['deployments'] }),
    errorLabel: 'Error deleting deployment',
    ...options,
  });
